import { School } from '../school';
import { Student } from '../student';
import { Lesson } from '../lesson';
import { Card } from '../card';
import { ReservationCancellationReason } from '../reservation-cancellation-reason';

export const enum ReservationStatus {
    'NEW',
    'ATTENDED',
    'CANCELLED',
    'NO_SHOW',
    'LESSON_CANCELLED',
    'WAITING_FOR_PAYMENT'
}

// Constants to know whether a reservation is payed by a Card or Enrollment
export const PAYED_PER_LESSON = 'PAYED_PER_LESSON';
export const PAYED_BY_ENROLLMENT = 'PAYED_BY_ENROLLMENT';
export const PAYED_BY_CARD = 'PAYED_BY_CARD';

export class Reservation {
    constructor(
        public id?: number,
        public status?: ReservationStatus,
        public school?: School,
        public student?: Student,
        public lesson?: Lesson,
        public cancellationReason?: ReservationCancellationReason,
        public totalPaid?: number,
        public belongsToCard?: boolean,
        public Card?: Card,
        public backofficeSessionId?: string,
        public isPayed?: boolean
    ) {
    }
}

// Represents a week with the number of reservations per day of week
export class ReservationWeek {

    public tuesday: Date;
    public wednesday: Date;
    public thursday: Date;
    public friday: Date;
    public saturday: Date;
    public sunday: Date;

    constructor(
        public monday: Date,
        public reservations: number[]
    ) {
        this.tuesday = new Date(this.monday);
        this.tuesday.setDate(this.monday.getDate() + 1);

        this.wednesday = new Date(this.tuesday);
        this.wednesday.setDate(this.wednesday.getDate() + 1);

        this.thursday = new Date(this.wednesday);
        this.thursday.setDate(this.thursday.getDate() + 1);

        this.friday = new Date(this.thursday);
        this.friday.setDate(this.friday.getDate() + 1);

        this.saturday = new Date(this.friday);
        this.saturday.setDate(this.saturday.getDate() + 1);

        this.sunday = new Date(this.saturday);
        this.sunday.setDate(this.sunday.getDate() + 1);
    }

    public getTotal(): number {
        let total = 0;

        if (this.reservations) {

            this.reservations.forEach(r =>
                total = total + r
            );
        }

        return total;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.model.ts